
import { Vue, Component, Prop } from "vue-property-decorator";
import { InjectService } from "@/modules/shared/decorators/inject-service.decorator";
import { IconsService } from "@/modules/shared/services/icons.service";
import { API_URL } from "@/core/environment";

@Component({})
export default class AppLoadIcon extends Vue {
  @InjectService()
  private readonly $iconsService!: IconsService;

  @Prop()
  public readonly iconId!: number;

  public get url(): string {
    return `${API_URL}/api/v1/icons/${this.iconId}`;
  }
}
